import { useController } from "react-hook-form";
import styled from "styled-components";

const Section = styled.section`
  margin: 0;
  padding: 3rem 1rem;
  background: ${({ $dark }) => ($dark ? "#000" : "#fff")};
  color: ${({ $dark }) => ($dark ? "#fff" : "#000")};
`;

const Chip = styled.button`
  border: none;
  border-radius: 20px;
  padding: 0.4rem 1.1rem;
  font-family: "Anybody", italic;
  font-size: 1.1rem;
  background: ${({ $active }) => ($active ? "#930707" : "#d9d9d9")};
  color: ${({ $active }) => ($active ? "#fff" : "#000")};
  cursor: pointer;
  transition: background 0.15s;
`;

export function RiffQuestion({ q, control, dark }) {
  const { field } = useController({
    name: q.id,
    control,
    defaultValue: q.type === "textarea" ? "" : [],
  });

  /* -------- textarea question -------- */
  if (q.type === "textarea") {
    return (
      <Section $dark={dark}>
        <h2>{q.title}</h2>
        <textarea
          rows={4}
          placeholder={q.placeholder}
          value={field.value}
          onChange={(e) => field.onChange(e.target.value)}
          style={{ width: "100%", padding: "1rem", fontFamily: "Anybody" }}
        />
      </Section>
    );
  }

  /* -------- chips question -------- */
  const toggle = (opt) => {
    const exists = field.value.includes(opt);
    const next = exists
      ? field.value.filter((v) => v !== opt)
      : [...field.value, opt].slice(-q.max);
    field.onChange(next);
  };

  return (
    <Section $dark={dark}>
      <h2>{q.title}</h2>
      <div style={{ display: "flex", flexWrap: "wrap", gap: ".6rem" }}>
        {q.options.map((opt) => (
          <Chip
            key={opt}
            $active={field.value.includes(opt)}
            onClick={() => toggle(opt)}
          >
            {opt}
          </Chip>
        ))}
      </div>
    </Section>
  );
}
